class ProductLightBox extends HTMLElement {

  constructor() {
    super();
    this.addListeners();
  }

  addListeners() {
    const productLightBoxOpen = document.querySelector('.js-product-lightbox-open');

    if (!productLightBoxOpen) return;

    productLightBoxOpen.addEventListener('click', () => {
      document.documentElement.classList.add('product-lightbox-active');
    });

    const productLightBoxClose= this.querySelectorAll('.js-product-lightbox-close');

    productLightBoxClose.forEach((el) => {
      el.addEventListener('click', () => {
        document.documentElement.classList.remove('product-lightbox-active');
      })
    })
  }
}

customElements.define('product-lightbox', ProductLightBox);
